import styles from "./resetpasswordblock1.module.css";
import InputEmailorPhone from "../InputEmailorPhone";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import SendOTPResetPassButton from "../SentOTPResetPassButton";

export default function ResetPasswordBlock1() {
  const { t } = useTranslation();
  const [errorEmailPhone, setErrorEmailPhone] = useState("");
  const [emailPhoneValue, setEmailPhoneValue] = useState("");
  return (
    <div className={styles.resetpassBlock}>
      <h2 className={styles.resetText}>{t("reset_pass")}</h2>
      <div className={`col-11 ${styles.inputBlock}`}>
        <div className={`col-11 ${styles.inputContainer}`}>
          <InputEmailorPhone
            emailPhoneValue={emailPhoneValue}
            setEmailPhoneValue={setEmailPhoneValue}
            errorEmailPhone={errorEmailPhone}
            setErrorEmailPhone={setErrorEmailPhone}
          />
          <span>{t(errorEmailPhone)}</span>
        </div>
      </div>
      <div className={styles.nextButtonContainer}>
        <SendOTPResetPassButton
          errorEmailPhone={errorEmailPhone}
          emailPhoneValue={emailPhoneValue}
          setErrorEmailPhone={setErrorEmailPhone}
          navigateTo={"?s=2"}
        />
      </div>
      <p className={styles.tosignupPage}>
        {t("first_time_bhive")} <a href="/signup">{t("signup")}</a>
      </p>
    </div>
  );
}
